const translations = {
    pt: {
        settingList: "Lista de Produtos",
        typeFilter: "Tipo de Produto",
        all: "Todos",
        nameFilter: "Nome",
        activeIngredientFilter: "Ingrediente Ativo",
        searchButton: "Buscar",
        fertilizer: "Fertilizante",
        pesticide: "Biodefensivo Agrícola",
        name: "Nome",
        activeIngredient: "Ingrediente Ativo",
        type: "Tipo",
        actions: "Ações",
        view: "Visualizar",
        link: "Anexar",
        delete: "Deletar",
        nosettings: "Nenhuma configuração encontrado.",
        previous: "Anterior",
        next: "Próximo",
        successDelete: "Produto deletado com sucesso!",
        errorDelete:
            "Não foi possível excluir o produto. Verifique se há capítulos vinculados a ele.",
        placeholderName: "Digite o nome do produto",
        placeholderActiveIngredient: "Digite o ingrediente ativo",
        settingInfo: "Editar Produto",
        settingType: "Tipo de Produto*",
        description: "Descrição*",
        storageMethod: "Método de Armazenamento*",
        formulation: "Formulação*",
        controlTarget: "Alvo de Controle*",
        activeConcentration: "Concentração Ativa*",
        recommendedDose: "Dose Recomendada*",
        applicationMethod: "Método de Aplicação*",
        benefit: "Benefícios*",
        saveButton: "Salvar Alterações",
        cancelButton: "Cancelar",
        successUpdate: "Produto atualizado com sucesso!",
        errorUpdate:
            "Falha ao atualizar o produto. Verifique os dados e tente novamente.",
        missingFields: "Campos obrigatórios faltando:",
        addsetting: "Adicionar Produto",
        addButton: "Adicionar",
        successAdd: "Produto adicionado com sucesso!",
        errorAdd:
            "Falha ao adicionar o produto. Verifique os dados e tente novamente.",
        placeholderDescription: "Descreva o produto",
        placeholderStorageMethod: "Ex.: Armazenar em local seco e fresco",
        placeholderFormulation: "Ex.: Líquido, Granulado",
        placeholderControlTarget: "Ex.: Pragas, Doenças",
        placeholderActiveConcentration: "Ex.: 100 g/L",
        placeholderRecommendedDose: "Ex.: 1 L/ha",
        placeholderApplicationMethod: "Ex.: Pulverização foliar",
        placeholderBenefit: "Descreva os benefícios do produto",
        confirmDelete: "Confirmar Exclusão",
        confirmDeleteMessage: "Tem certeza que deseja deletar este produto?",
        confirmButton: "Confirmar",
        linkTo: "Vincular \"",
        toChapter: "\" a um capítulo...",
        selectBook: "Selecione um Livro",
        selectChapter: "Selecione um Capítulo",
        linkButton: "Vincular",
        chaptersettings: "Produtos Vinculados a este Capítulo",
        settingChapters: "Capítulos Vinculados a este Produto",
        noBooks: "Nenhum livro encontrado.",
        noChapters: "Nenhum capítulo encontrado.",
        noLinkedsettings: "Nenhum produto vinculado.",
        noLinkedChapters: "Nenhum capítulo vinculado.",
        successLink: "Produto vinculado com sucesso!",
        errorLink: "Falha ao vincular o produto.",
        successUnlink: "Capítulo desvinculado com sucesso!",
        errorUnlink: "Falha ao desvincular o capítulo.",
        selectBookPrompt: "Selecione um livro",
        selectChapterPrompt: "Selecione um capítulo",
        loading: "Carregando...",
        unlinkButton: "Desvincular",
        showing: "Mostrando",
        of: "de",
        settings: "produtos",
        failedToFetch: "Falha ao buscar produtos.",
        configList: "Lista de Configurações",
        addConfig: "Adicionar Configuração",
        configInfo: "Editar Configuração",
        key: "Chave",
        value: "Valor",
        createdAt: "Criado Em",
        keyFilter: "Chave",
        descriptionFilter: "Descrição",
        placeholderKey: "Digite a chave da configuração",
        placeholderValue: "Digite o valor da configuração",
        noConfigs: "Nenhuma configuração encontrada.",
        successAddConfig: "Configuração adicionada com sucesso!",
        errorAddConfig: "Falha ao adicionar a configuração. Verifique os dados e tente novamente.",
        successUpdateConfig: "Configuração atualizada com sucesso!",
        errorUpdateConfig: "Falha ao atualizar a configuração. Verifique os dados e tente novamente.",
        successDeleteConfig: "Configuração deletada com sucesso!",
        errorDeleteConfig: "Falha ao deletar a configuração.",
        confirmDeleteConfig: "Confirmar Exclusão de Configuração",
        confirmDeleteConfigMessage: "Tem certeza que deseja deletar esta configuração?",
        configs: "configurações"
    },
    en: {
        settingList: "setting List",
        typeFilter: "setting Type",
        all: "All",
        nameFilter: "Name",
        activeIngredientFilter: "Active Ingredient",
        searchButton: "Search",
        fertilizer: "Fertilizer",
        pesticide: "Bioagricultural Pesticide",
        name: "Name",
        activeIngredient: "Active Ingredient",
        type: "Type",
        actions: "Actions",
        view: "View",
        link: "Attach",
        delete: "Delete",
        nosettings: "No settings found.",
        previous: "Previous",
        next: "Next",
        successDelete: "setting deleted successfully!",
        errorDelete:
            "Failed to delete the setting. Please check if there are any chapters linked to it.",
        placeholderName: "Enter the setting name",
        placeholderActiveIngredient: "Enter the active ingredient",
        settingInfo: "Edit setting",
        settingType: "setting Type*",
        description: "Description*",
        storageMethod: "Storage Method*",
        formulation: "Formulation*",
        controlTarget: "Control Target*",
        activeConcentration: "Active Concentration*",
        recommendedDose: "Recommended Dose*",
        applicationMethod: "Application Method*",
        benefit: "Benefits*",
        saveButton: "Save Changes",
        cancelButton: "Cancel",
        successUpdate: "setting updated successfully!",
        errorUpdate:
            "Failed to update the setting. Please check the data and try again.",
        missingFields: "Required fields missing:",
        addsetting: "Add setting",
        addButton: "Add",
        successAdd: "setting added successfully!",
        errorAdd:
            "Failed to add the setting. Please check the data and try again.",
        placeholderDescription: "Describe the setting",
        placeholderStorageMethod: "Ex.: Store in a cool, dry place",
        placeholderFormulation: "Ex.: Liquid, Granular",
        placeholderControlTarget: "Ex.: Pests, Diseases",
        placeholderActiveConcentration: "Ex.: 100 g/L",
        placeholderRecommendedDose: "Ex.: 1 L/ha",
        placeholderApplicationMethod: "Ex.: Foliar spray",
        placeholderBenefit: "Describe the setting benefits",
        confirmDelete: "Confirm Deletion",
        confirmDeleteMessage: "Are you sure you want to delete this setting?",
        confirmButton: "Confirm",
        linkTo: "Link \"",
        toChapter: "\" to a chapter...",
        selectBook: "Select a Book",
        selectChapter: "Select a Chapter",
        linkButton: "Link",
        chaptersettings: "settings Linked to This Chapter",
        settingChapters: "Chapters Linked to This setting",
        noBooks: "No books found.",
        noChapters: "No chapters found.",
        noLinkedsettings: "No settings linked.",
        noLinkedChapters: "No chapters linked.",
        successLink: "setting linked successfully!",
        errorLink: "Failed to link the setting.",
        successUnlink: "Chapter unlinked successfully!",
        errorUnlink: "Failed to unlink the chapter.",
        selectBookPrompt: "Select a book",
        selectChapterPrompt: "Select a chapter",
        loading: "Loading...",
        unlinkButton: "Unlink",
        showing: "Showing",
        of: "of",
        settings: "settings",
        failedToFetch: "Failed to fetch settings.",
        configList: "Config List",
        addConfig: "Add Config",
        configInfo: "Edit Config",
        key: "Key",
        value: "Value",
        createdAt: "Created At",
        keyFilter: "Key",
        descriptionFilter: "Description",
        placeholderKey: "Enter the config key",
        placeholderValue: "Enter the config value",
        noConfigs: "No configs found.",
        successAddConfig: "Config added successfully!",
        errorAddConfig: "Failed to add the config. Please check the data and try again.",
        successUpdateConfig: "Config updated successfully!",
        errorUpdateConfig: "Failed to update the config. Please check the data and try again.",
        successDeleteConfig: "Config deleted successfully!",
        errorDeleteConfig: "Failed to delete the config.",
        confirmDeleteConfig: "Confirm Config Deletion",
        confirmDeleteConfigMessage: "Are you sure you want to delete this config?",
        configs: "configs"
    },
};

export default translations;